import i18nHelper from '../../../core/services/i18n.service';
import http from "../../../core/services/http.service";

const AccountingService = {
  getAccountingSystemInfo(params = null) {
    return http.get('/api/v1/finances/accounting/info/', {params});
  },
  connectToAccountingSystem() {
    return http.post(`/api/v1/finances/accounting/connect/`);
  },
  pushAccountingSystemInfo(params) {
    return http.get(`/api/v1/finances/accounting/callback/`, {params});
  },
  syncWithAccountingSystem(data) {
    return http.post(`/api/v1/finances/accounting/sync/`, data);
  },
  saveTenant(tenantId) {
    return http.post(`/api/v1/finances/accounting/save-tenant/`, {tenant_id: tenantId})
  },
  getAccountingSyncLog(params) {
    return http.get(`api/v1/finances/accounting-sync-log/`, {params})
  }
}

export default AccountingService;
